export enum RightsEnum {
    View = 1,
    Create = 2,
    Update = 3,
    Delete = 4,
    RunAlgorithm = 8,
    CanEnable = 5,
    CanEnableTicket = 6,
    BulkImport = 7
}